import React, { PropsWithChildren } from 'react';
import { Tooltip } from '@duxton-web/ui';
import styled from 'styled-components';

interface RestrictedEditingWrapperProps {
  isRestricted: boolean;
  tooltipMessage: string;
  className?: string;
}

const RestrictedEditingWrapper = ({
  children,
  isRestricted,
  tooltipMessage,
  className,
}: PropsWithChildren<RestrictedEditingWrapperProps>) => {
  if (!isRestricted) {
    return <>{children}</>;
  }

  return (
    <Tooltip title={tooltipMessage} placement="top">
      <DisabledOverlay isRestricted={isRestricted} className={className}>
        <TooltipWrapper>{children}</TooltipWrapper>
      </DisabledOverlay>
    </Tooltip>
  );
};

export default RestrictedEditingWrapper;

const DisabledOverlay = styled.div<{ isRestricted: boolean }>`
  position: relative;

  ${({ isRestricted }) =>
    isRestricted &&
    `
    opacity: 0.5;
    cursor: not-allowed;
    & > * {
      pointer-events: none;
    }
  `}
`;

const TooltipWrapper = styled.div`
  height: 100%;
  width: 100%;
`;
